import { useActiveTabFromMatch } from "@shared";

import { AppRoutes } from "@/router/AppRoutes";
import {
  AssetInventorySubTab,
  BankruptcyChecklistSubTab,
  ClientMasterDataTab,
  ClientTab,
  DebtSettlementSubTab,
} from "@/router/ClientRoutes";

export const SEARCH_PARAM = "searchParam";

const SubTabParamName = "subTab";

export function useActiveClientTab(): ClientTab | undefined {
  return useActiveTabFromMatch(`${AppRoutes.Clients}/:id/:tab/*`, ClientTab);
}

export function useActiveMasterDataTab(): ClientMasterDataTab | undefined {
  return useActiveTabFromMatch(
    `${AppRoutes.Clients}/:id/${ClientTab.MasterData}/:${SubTabParamName}`,
    ClientMasterDataTab,
    SubTabParamName
  );
}

export function useActiveDebtSettlementTab(): DebtSettlementSubTab | undefined {
  return useActiveTabFromMatch(
    `${AppRoutes.Clients}/:id/${ClientTab.DebtSettlement}/:${SubTabParamName}/*`,
    DebtSettlementSubTab,
    SubTabParamName
  );
}

export function useActiveAssetInventorySubTab(): AssetInventorySubTab | undefined {
  return useActiveTabFromMatch(
    `${AppRoutes.Clients}/:id/${ClientTab.DebtSettlement}/${DebtSettlementSubTab.AssetInventory}/:${SubTabParamName}`,
    AssetInventorySubTab,
    SubTabParamName
  );
}

export function useActiveBankruptcyChecklistSubTab(): BankruptcyChecklistSubTab | undefined {
  return useActiveTabFromMatch(
    `${AppRoutes.Clients}/:id/${ClientTab.DebtSettlement}/${DebtSettlementSubTab.BankruptcyChecklist}/:${SubTabParamName}`,
    BankruptcyChecklistSubTab,
    SubTabParamName
  );
}
